import { AppState, LoginPage, useAuth } from "@jana-technology/platform-ui";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { DEFAULT_ROUTE } from "constants/routing";

export const Login = () => {
  const auth = useAuth();

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated && auth.user) {
      navigate(DEFAULT_ROUTE);
    }
  }, [auth.isAuthenticated, auth.user, navigate]);

  const appState = location.state as AppState<void>;

  return <LoginPage product="storage" appState={appState} />;
};

export default Login;
